export enum AnswerEngineTypesEnum {
    CHATGPT = 'CHATGPT',
    COPILOT = 'COPILOT',
    GEMINI = 'GEMINI',
    PERPLEXITY = 'PERPLEXITY',
    CLAUDE = 'CLAUDE',
    GROK = 'GROK',
    MISTRAL = 'MISTRAL',
    LLAMA = 'LLAMA'
}
